import Navbar from './components/Navbar';
import HeroBanner from './components/HeroBanner';
import HotProducts from './components/HotProducts';
import HomeAbout from './components/HomeAbout';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1">
        <HeroBanner />
        <HotProducts />
        <HomeAbout />
      </main>
      <Footer />
    </div>
  );
}
